'use strict';

// Init mobile menu and off-canvas
const mobileMenu = new MobileMenu();
document.addEventListener('mobilemenu-init-done', () => {
	var offCanvas = new OffCanvas({
		debug: false,
		overlay: true,
	})

	// Event listeners for off-canvas
	// offCanvas.mainWrap.addEventListener('open', e => {
	// 	console.log(e.detail)
	// })

	// offCanvas.mainWrap.addEventListener('close', e => {
	// 	console.log(e.detail)
	// })
});
mobileMenu.init();

// Init events pager
const eventsPager = new EventsPager();
eventsPager.init();

// Init card filters
const cardFilters = new CardFilters();
cardFilters.init();

// Responsive tables
document.querySelectorAll('main > table').forEach((table) => {
	const tableWrapper = document.createElement('div');
	tableWrapper.classList.add('table-wrapper');
	tableWrapper.classList.add('overflow-x-auto');
	table.parentNode.insertBefore(tableWrapper, table);
	tableWrapper.appendChild(table);
});
